/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  TunneledMcpConnection,
  TunneledMcpConnection$inboundSchema,
} from "./tunneledmcpconnection.js";

/**
 * Live connection details for a tunneled MCP server
 */
export type TunneledMcpServerConnections = {
  /**
   * Number of active tunnel connections currently visible in Redis
   */
  activeConnectionCount: number;
  /**
   * Total MCP consumer sessions currently pinned across active tunnel connections
   */
  activeConsumerSessionCount: number;
  /**
   * Live tunnel connections currently visible in Redis
   */
  connections: Array<TunneledMcpConnection>;
};

/** @internal */
export const TunneledMcpServerConnections$inboundSchema: z.ZodMiniType<
  TunneledMcpServerConnections,
  unknown
> = z.pipe(
  z.object({
    active_connection_count: z.int(),
    active_consumer_session_count: z.int(),
    connections: z.array(TunneledMcpConnection$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "active_connection_count": "activeConnectionCount",
      "active_consumer_session_count": "activeConsumerSessionCount",
    });
  }),
);

export function tunneledMcpServerConnectionsFromJSON(
  jsonString: string,
): SafeParseResult<TunneledMcpServerConnections, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TunneledMcpServerConnections$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TunneledMcpServerConnections' from JSON`,
  );
}
